// 变更状态
export default {
	shouQFn (state) {
      state.shouQ=!state.shouQ;
    },
    increment (state) {
      state.shouQ=!state.shouQ;
    },
    SET_CONTENT(state,str) {
    state.content=str
  },
  SET_COMPANYTD(state,str) {
    state.companyIds=str
  },
}


// WEBPACK FOOTER //
// ./src/vuex/mutations.js